<template>
  <div class="payment-container">
    <v-layout row wrap>
      <v-flex lg4 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">ADD A CALL TO ACTION</h1>
              <div class="title-decoration"></div>
            </div>
            <v-container>
              <v-form @submit.prevent="postCallToAction()" ref="form" v-model="valid">
                <v-text-field
                  label="Title"
                  v-model="call_to_action.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
                <v-textarea
                  label="Description"
                  v-model="call_to_action.description"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                  rows="3"
                ></v-textarea>
                <v-btn 
                  depressed 
                  color="#587e27" 
                  block 
                  type="submit" 
                  class="futuristic-btn rounded-btn"
                >
                  Add Call to Action
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg8 md6 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <div class="card-header">
              <h1 class="earth-color">CALL TO ACTIONS</h1>
              <div class="title-decoration"></div>
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="search"
                placeholder="Search"
                single-line
                hide-details
                v-model="search"
                class="futuristic-search"
              ></v-text-field>
            </div>
            <v-container class="table-container">
              <v-data-table
                :headers="columns"
                :items="allCallToActions"
                :search="search"
                :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
                :disable-initial-sort="true"
                :loading="$loadingTrue"
                class="futuristic-table"
                hide-actions
              >
                <v-progress-linear
                  slot="progress"
                  color="#587e27"
                  indeterminate
                  height="3"
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td class="font-weight-medium">{{ props.item.name }}</td>
                  <td>{{ props.item.description }}</td>
                  <td class="has-text-right">
                    <v-btn 
                      depressed 
                      color="#f44336" 
                      small 
                      @click="deleteCallToAction(props.item.public_id)"
                      class="futuristic-btn rounded-btn action-btn"
                    >
                      Disable
                    </v-btn>
                  </td>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ search }}" found no results.
                </v-alert>
                <template slot="no-data">
                  <div class="text-xs-center py-4">
                    No call to actions available
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'call-to-actions',
  data () {
    return {
      valid: true,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      search: '',
      columns: [
        {
          text: 'Name',
          value: 'name',
          class: 'table-header'
        },
        {
          text: 'Description',
          value: 'description',
          class: 'table-header'
        },
        {
          text: 'Action',
          value: '',
          class: 'table-header',
          align: 'right'
        }
      ],
      call_to_action: {
        name: '',
        description: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_call_to_actions')
  },
  methods: {
    postCallToAction: function () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('post_call_to_action', this.call_to_action)
      }
    },
    deleteCallToAction: function (publicId) {
      if(confirm('Are you sure you want to disable this call to action?')) {
        this.$store.dispatch('delete_call_to_action', publicId)
      }
    }
  }
}
</script>

<style scoped>
/* Futuristic Container */
.payment-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.payment-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
  margin-right: 20px;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
  flex-basis: 100%;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  height: 100%;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.futuristic-btn {
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.rounded-btn {
  border-radius: 24px !important;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  min-width: auto;
  padding: 0 12px;
}

.table-container {
  padding: 0;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .payment-container {
    padding: 12px;
  }
  
  .card-header {
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .earth-color {
    font-size: 1.35rem;
    margin-bottom: 10px;
    margin-right: 0;
  }
  
  .futuristic-search {
    width: 100%;
    margin-top: 10px;
  }
}

@media (max-width: 600px) {
  .payment-container {
    padding: 8px;
    border-radius: 6px;
  }
  
  .card-header {
    padding: 8px;
  }
  
  .earth-color {
    font-size: 1.2rem;
  }
  
  .action-btn {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>